import * as React from 'react';
import {
  makeStyles,
  tokens,
  Button,
  Input,
  Field,
  MessageBar,
  MessageBarBody,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  field: {
    width: '100%',
  },
  button: {
    width: '100%',
    marginTop: tokens.spacingVerticalS,
  },
  backLink: {
    textAlign: 'center',
    marginTop: tokens.spacingVerticalM,
    fontSize: tokens.fontSizeBase300,
  },
  link: {
    color: tokens.colorBrandForeground1,
    textDecoration: 'none',
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
});

interface ForgotPasswordFormProps {
  getFieldProps: (fieldName: string) => any;
  errors: Record<string, string>;
  onSubmit: (e: React.FormEvent) => void;
  loading: boolean;
  error: string | null;
  onBackToLogin: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  getFieldProps,
  errors,
  onSubmit,
  loading,
  error,
  onBackToLogin,
}) => {
  const styles = useStyles();

  return (
    <form onSubmit={onSubmit} className={styles.form}>
      {error && (
        <MessageBar intent="error">
          <MessageBarBody>{error}</MessageBarBody>
        </MessageBar>
      )}

      <Field
        label="E-mail"
        validationMessage={errors.email}
        validationState={errors.email ? 'error' : 'none'}
        className={styles.field}
      >
        <Input
          type="email"
          size="large"
          placeholder="Digite seu e-mail"
          {...getFieldProps('email')}
        />
      </Field>

      <Button
        type="submit"
        appearance="primary"
        disabled={loading}
        className={styles.button}
      >
        {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
      </Button>

      <div className={styles.backLink}>
        <span
          className={styles.link}
          onClick={onBackToLogin}
        >
          Voltar ao Login
        </span>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;